import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Animations {
  constructor() {
    this.teaser = null;

    this.init();
  }

  createIntro() {
    // teaser topic
    const teaserSection = document.querySelector('.animation-intro');
    const introDelay = parseFloat(teaserSection.querySelector('.module-start-hero').dataset.delay / 1000);

    teaserSection.classList.add('loaded');
    teaserSection.querySelectorAll('.module-article-teaser .img-parallax ~ div').forEach(el => {
      el.style.opacity = 1;
    });

    this.teaser = gsap.context(() => {
      const tl = gsap.timeline({delay: introDelay || 0});
      tl.from('.img-left', {y: -50, autoAlpha: 0, duration: 1});
      tl.from('.img-right', {y: 50, autoAlpha: 0, duration: 1}, '-=1');
      tl.to('.img-parallax', {
        y: () => document.querySelector('.img-parallax').clientHeight * -1 + 66,
        duration: 3,
        scrollTrigger: {
          // markers: true,
          trigger: teaserSection,
          scrub: 1,
          start: 'top 80px',
          end: () => '+=' + document.querySelector('.img-parallax').clientHeight,
          pin: true
        }
      });

      return () => {
        tl.kill();
      };
    }, teaserSection);
  }

  init() {
    if (!document.querySelector('.animation-intro')) return; // return if no animation-intro

    gsap.set('.img-parallax', {zIndex: 2});
    this.createIntro();
    window.addEventListener('resize', () => {
      if (this.teaser) {
        this.teaser.revert();
      }

      this.createIntro();
    });
  }
}
